import React from "react";
import { Route, Redirect } from "react-router-dom";
import HelpDeskLayout from "../layouts/HelpDeskLayout";
import BiometricLayout from "../layouts/BiometricLayout";
import _authService from "modules/AuthService.js";
import NetworkDetector from "../HOC/NetworkDetector";

const BiometricRoute = ({ component: Component, layout: Layout, role: role, menuId: menuId, ...rest }) => (
    <Route key={Math.floor((Math.random() * 9999999) + 1)} {...rest} render={props => (
        //Also check role
        _authService.isBiometricAdminAuthenticated()
            ?
            <BiometricLayout componentName={menuId}>
                <Component {...props} />
            </BiometricLayout>
            :
            <Redirect to={{
                pathname: '/biometricadmin/login'
            }} />
    )} />
)

export default NetworkDetector(BiometricRoute)